<template lang="">
  <div class="RelationtItem" @click="editorRelation">
    <div class="item-radio" v-if="isShowRadio" @click.stop>
      <van-checkbox v-model="checked" shape="square"></van-checkbox>
    </div>
    <div class="item-content">
      <van-field input-align="right" label="姓名">
        <template #input>
          <div class="l">
            {{ item.name }}
            <a
              class="phone"
              :href="`tel:${item.mobile}`"
              @click.stop
              v-if="item.mobile"
              >- {{ item.mobile | dash }} <van-icon name="phone"
            /></a>
          </div>
        </template>
      </van-field>
      <van-field
        :value="item.post | dash"
        readonly
        input-align="right"
        label="职位"
      />
      <van-field
        :value="item.parentName | dash"
        readonly
        input-align="right"
        label="直属上级"
      />
      <van-field
        :value="item.master ? '是' : '否'"
        label-width="100px"
        readonly
        input-align="right"
        label="是否关键决策人"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "RelationtItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isShowRadio: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked: {
      get() {
        return this.item.checked;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
    setName() {
      let { name, mobile } = this.item;
      return `${[name, mobile].filter(Boolean).join("-")}`;
    },
  },
  methods: {
    editorRelation() {
      this.$router.push({
        path: "/relation/create",
        query: {
          id: this.item.id,
          customerId: this.item.customerId,
          name: this.item.customerName,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.RelationtItem {
  display: flex;
  align-items: center;
  background-color: #fff;
  margin-top: 10px;
  .phone {
    color: #3c86ff;
  }
  .item-radio {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .item-content {
    flex: 1;
  }
}
</style>
